import moment from 'moment'

import { IndexDTO } from '../store/StateObjects'

type FilterData = (
  data: IndexDTO[],
  state: string[],
  region: string[],
  indexType: string[],
  startDate?: Date,
  endDate?: Date,
) => IndexDTO[]

export const filterData: FilterData = (data, state, region, indexType, startDate, endDate) => {
  const today = new Date()

  // NOTE: Business rule is to show previous 12 months by default
  const calculatedStartDate = startDate ?? moment(today).subtract(12, 'months').toDate()
  const calculatedEndDate = endDate ?? today

  return data?.filter(
    (index) =>
      state.indexOf(index.state) > -1 &&
      region.indexOf(index.region) > -1 &&
      indexType.indexOf(index.index_type) > -1 &&
      index.week &&
      moment(index.week, 'DD/MM/YYYY').isBetween(
        moment(calculatedStartDate),
        moment(calculatedEndDate),
        undefined,
        '[]',
      ),
  )
}

export const getNextUpdateDate = (lastUpdateDate: string): string =>
  lastUpdateDate ? moment(lastUpdateDate, 'DD MMMM YYYY').add(7, 'days').format('D MMMM YYYY') : ''
